import { useEffect, useState } from 'react'

/**
 * @reference https://api.ipify.org/?format=json
 * @returns `ip` for example: `45.71.42.252`
 */
export function useIPNetwork() {
  const [IPNetwork, setIPNetwork] = useState('')

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await fetch('https://api.ipify.org/?format=json')
        const data = await response.json()
        setIPNetwork(data.ip)
      } catch (error) {
        console.error('Error fetching IP:', error)
      }
    }

    fetchIP()
  }, [])

  return IPNetwork
}
